export class BomIdsRequest {
    packingMaterialId: number[];
    vendorId: number;
    unitId?: number;
}